export const CALENDAR_HEIGHT = 370;
